import { DropdownButton, DropdownButtonItem } from '@salecycle/ui-component-library';
import { Campaign } from 'entities/campaign';
import { FeatureTypes } from 'entities/campaign/features';
import { State as LifeCycleState } from 'entities/lifecycle';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Actions as RouterActions } from 'router';
import { Actions } from 'sections/campaigns/state/campaigns';

interface IOwnProps {
  campaignId: string;
  campaign: Campaign;
  siteId: string;
  editEnabled?: boolean;
  cloneEnabled?: boolean;
  updateLocalOnly?: boolean;
}

interface IDispatchProps {
  push: (href: string) => void;
  update: (campaignId: string, campaign: Campaign) => void;
  updateLocal: (campaignId: string, campaign: Campaign) => void;
  updateQuery: (query: { [key: string]: string }) => void;
}

export type IProps = IOwnProps & IDispatchProps;

export const CampaignActionsButton: FC<IProps> = (props: IProps) => {
  const { t } = useTranslation('campaigns');
  const onChange = (state: LifeCycleState) => {
    const updatedEntity = {
      ...props.campaign,
      state,
    };
    props.updateLocalOnly
      ? props.updateLocal(props.campaignId, updatedEntity)
      : props.update(props.campaignId, updatedEntity);
  };
  const editClick = () => props.push(`/sites/${props.siteId}/campaigns/campaigns/${props.campaignId}`);
  const onClone = () => props.updateQuery({ clone: 'true', campaign_id: props.campaignId });
  const onStart = () => onChange('ACTIVE');
  const onPause = () => onChange('INACTIVE');
  const onDelete = () => onChange('DELETED');
  const onTest = () => onChange('TESTING');
  const onMigration = () => onChange('MIGRATION');

  return (
    <DropdownButton variation="clean" icon="ellipsis-v" menuPlacement="right">
      {props.editEnabled && (
        <DropdownButtonItem onClick={editClick}>{t('campaigns:campaignActions.edit')}</DropdownButtonItem>
      )}
      {props.campaign.state === 'ACTIVE' ? (
        <DropdownButtonItem onClick={onPause}>{t('campaigns:campaignActions.pause')}</DropdownButtonItem>
      ) : null}
      {props.campaign.state === 'INACTIVE' ? (
        <DropdownButtonItem onClick={onStart}>{t('campaigns:campaignActions.start')}</DropdownButtonItem>
      ) : null}
      {props.campaign.state !== 'DELETED' ? (
        <DropdownButtonItem onClick={onDelete}>{t('campaigns:campaignActions.archive')}</DropdownButtonItem>
      ) : (
        <DropdownButtonItem onClick={onPause}>{t('campaigns:campaignActions.restore')}</DropdownButtonItem>
      )}
      {props.campaign.state === 'INACTIVE' || props.campaign.state === 'ACTIVE' ? (
        <>
          <DropdownButtonItem onClick={onTest}>{t('campaigns:campaignActions.test')}</DropdownButtonItem>
        </>
      ) : null}
      {props.campaign.state === 'MIGRATION' ? (
        <>
          <DropdownButtonItem onClick={onTest}>{t('campaigns:campaignActions.test')}</DropdownButtonItem>
          <DropdownButtonItem onClick={onStart}>{t('campaigns:campaignActions.start')}</DropdownButtonItem>
        </>
      ) : null}
      {props.campaign.state === 'TESTING' ? (
        <>
          <DropdownButtonItem onClick={onStart}>{t('campaigns:campaignActions.start')}</DropdownButtonItem>
        </>
      ) : null}
      {props.cloneEnabled && (
        <DropdownButtonItem onClick={onClone}>{t('campaigns:campaignActions.clone')}</DropdownButtonItem>
      )}
      {(props.campaign.state === 'INACTIVE' ||
        props.campaign.state === 'ACTIVE' ||
        props.campaign.state === 'TESTING') &&
      props.campaign.type !== FeatureTypes.MPS ? (
        <DropdownButtonItem onClick={onMigration}>{t('campaigns:campaignActions.migrate')}</DropdownButtonItem>
      ) : null}
    </DropdownButton>
  );
};

const actions: IDispatchProps = {
  push: RouterActions.push,
  update: Actions.requestUpdate,
  updateLocal: Actions.updateLocal,
  updateQuery: RouterActions.updateQuery,
};

export default connect(null, actions)(CampaignActionsButton);
